import './style/customEditorStyle.scss'

const CustomToolbar = ({ handleInsertVariableClick, canInsertVariables, showInsertVariableOnly, toolbarId }) => {
  const insertButton = canInsertVariables && (
    <button className="ql-insertVariable" type="button" onClick={handleInsertVariableClick}>
      Insert Variable
    </button>
  )

  if (showInsertVariableOnly) {
    return <div id={toolbarId || 'custom-toolbar'}>{insertButton}</div>
  }

  return (
    <div id={toolbarId || 'custom-toolbar'}>
      <select className="ql-header" defaultValue="">
        <option value="1"></option>
        <option value="2"></option>
        <option value="3"></option>
        <option value="4"></option>
        <option value="5"></option>
        <option value="6"></option>
        <option value=""></option>
      </select>
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-align" value="" />
      <button className="ql-align" value="center" />
      <button className="ql-align" value="right" />
      <button className="ql-link" />
      <button className="ql-image" />
      <select className="ql-color" defaultValue="">
        <option value="red"></option>
        <option value="green"></option>
        <option value="blue"></option>
        <option value="orange"></option>
        <option value="violet"></option>
        <option value="#d0d1d2"></option>
        <option value=""></option>
      </select>
      {insertButton}
    </div>
  )
}

export default CustomToolbar
